import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

const LIST_KEYS = ["seoList1", "seoList2", "seoList3", "seoList4"];

export default function SeoSection() {
  const { t } = useTranslation();

  return (
    <section className="mx-auto w-full max-w-7xl px-4 py-16 md:px-6 md:py-20">
      <div className="grid grid-cols-1 items-center gap-10 lg:grid-cols-2 lg:gap-14">
        <div>
          <h2 className="font-heading text-2xl font-bold text-foreground-950 md:text-3xl">
            {t("seoH2")}
          </h2>
          <p className="mt-5 text-base leading-relaxed text-foreground-700">{t("seoP1")}</p>
          <p className="mt-4 text-base leading-relaxed text-foreground-700">{t("seoP2")}</p>

          <ul className="mt-6 space-y-3">
            {LIST_KEYS.map((key) => (
              <li key={key} className="flex items-start gap-3 text-sm text-foreground-700 md:text-base">
                <span className="mt-0.5 flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-primary-100 text-primary-700">
                  <i className="ri-check-line text-sm"></i>
                </span>
                {t(key)}
              </li>
            ))}
          </ul>
        </div>

        <div className="flex flex-col rounded-lg border border-background-200 bg-background-100 p-6 md:p-8">
          <span className="flex h-12 w-12 items-center justify-center rounded-lg bg-primary-500 text-white">
            <i className="ri-book-open-line text-xl"></i>
          </span>
          <h3 className="mt-5 font-heading text-xl font-semibold text-foreground-950">
            {t("seoCardTitle")}
          </h3>
          <p className="mt-3 text-sm leading-relaxed text-foreground-600 md:text-base">
            {t("seoCardDesc")}
          </p>
          <Link
            to="/usfans-spreadsheet-guide"
            className="mt-6 inline-flex w-fit items-center gap-2 whitespace-nowrap rounded-full bg-primary-500 px-6 py-3 text-sm font-semibold text-white transition-colors hover:bg-primary-600"
          >
            {t("seoReadMore")}
            <span className="flex h-4 w-4 items-center justify-center">
              <i className="ri-arrow-right-line text-sm"></i>
            </span>
          </Link>
        </div>
      </div>
    </section>
  );
}